export const toggleSelect = <T extends unknown>(line: T, lines: T[]): T[] => {
	return lines.indexOf(line) > -1 ? lines.filter(t => t !== line) : [...lines, line];
};
